// utils/permissions.js
export const normalizePermissions = (user) => {
  if (user?.role?.token === "super-admin") {
    return ["__ALL__"];
  }

  if (Array.isArray(user?.role?.permissions)) {
    return user.role.permissions.map((p) => p.token);
  }

  if (Array.isArray(user?.permissions)) {
    return user.permissions.map((p) =>
      typeof p === "string" ? p : p.token
    );
  }

  return [];
};

export const hasPermission = (userPermissions, permissionName) => {
  if (!userPermissions || !Array.isArray(userPermissions)) return false;
  
  // Check for super admin access
  if (userPermissions.includes("__ALL__")) return true;
  
  return userPermissions.includes(permissionName);
};

export const hasAnyPermission = (userPermissions, required = []) => {
  if (!required || required.length === 0) return true;
  if (userPermissions.includes("__ALL__")) return true;
  return required.some((p) => userPermissions.includes(p));
};

export const hasAllPermissions = (userPermissions, required = []) => {
  if (!required || required.length === 0) return true;
  if (userPermissions.includes("__ALL__")) return true;
  return required.every((p) => userPermissions.includes(p));
};